export default {
  state: () => ({
    myInfo: {},
    profileUpdateSchema: [],
    parentUserSchema: [],
    userId: null,
    clientId: null,
    clientInfo: {}
  })
}



// WEBPACK FOOTER //
// ./src/app/store/profile/config.js